// auth.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '../renew/services/auth-service.service';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard implements CanActivate {
    constructor(private authService: AuthService, private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (this.authService.isLoggedIn()) {
            return true;
        } else {
            // Stocker l'URL sécurisée que l'utilisateur voulait atteindre
            sessionStorage.setItem('redirectUrl', state.url);

            // Rediriger vers la page de connexion
            this.router.navigate([""]); // Change "" en "/login" si c'est la route correcte
            return false;
        }
    }

}
